module.exports = __webpack_public_path__ + "06.png?dfe62d9ab1bb7def6a5265101df63294";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshots/06.png
// module id = 120
// module chunks = 3